export type ProjectType = 'od-nuly' | 'redesign';
export type ProjectCategory =
  | 'E-shop'
  | 'Webová stránka'
  | 'E-shop + Marketing'
  | 'Marketing'
  | 'Firemný web'
  | 'CRM & Systémy'
  | 'Osobný brand';

export interface Project {
  id: number;
  name: string;
  category: ProjectCategory;
  type: ProjectType;
  tags: string[];
  result: string;
  resultDetail: string;
  description: string;
  caseStudyLink?: string;
  image?: string;
  beforeImage?: string;
  afterImage?: string;
  liveUrl?: string;
}

export const projects: Project[] = [
  {
    id: 1,
    name: 'ICF House',
    category: 'Firemný web',
    type: 'od-nuly',
    tags: ['React', 'Lead Form', 'Stavebníctvo'],
    result: 'Online dopyty',
    resultDetail: 'moderný web pre stavebnú firmu s dôrazom na technológiu a dôveru',
    description: 'React webová stránka pre stavebnú firmu. Dôraz na moderné technológie, dôveryhodnosť a generovanie dopytov.',
    liveUrl: 'https://icfhouse.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://icfhouse.sk',
  },
  {
    id: 2,
    name: 'Salón Sirka',
    category: 'Webová stránka',
    type: 'od-nuly',
    tags: ['React', 'Rezervácie', 'Salon'],
    result: 'Online rezervácie',
    resultDetail: 'čistá lokálna prezentácia so systémom rezervácií priamo na webe',
    description: 'React webstránka pre salón krásy. Zameranie na služby, online rezervácie a čistú lokálnu prezentáciu.',
    liveUrl: 'https://salonsirka.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://salonsirka.sk',
  },
  {
    id: 3,
    name: 'Glow Dent',
    category: 'Webová stránka',
    type: 'od-nuly',
    tags: ['WordPress', 'Lead Form', 'Zdravotníctvo'],
    result: 'Online objednávky',
    resultDetail: 'dentálna klinika s dôrazom na dôveru a jednoduchosť objednávania',
    description: 'WordPress web pre zubnú kliniku. Dôraz na dôveryhodnosť, rezervačný formulár a prehľadnú prezentáciu služieb.',
    liveUrl: 'https://glowdent.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://glowdent.sk',
  },
  {
    id: 4,
    name: 'Pizza Maxim',
    category: 'Webová stránka',
    type: 'od-nuly',
    tags: ['React', 'Menu', 'Gastronomia'],
    result: 'Jednoduché objednávanie',
    resultDetail: 'pizzeria s výrazným vizuálom a dôrazom na prehľadné objednávanie',
    description: 'React web pre pizzeriu. Silný vizuálny dojem, prehľadné menu a dôraz na jednoduché objednávanie.',
    liveUrl: 'https://pizzamaxim.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://pizzamaxim.sk',
  },
  {
    id: 5,
    name: 'Boxy Nosiče',
    category: 'Webová stránka',
    type: 'od-nuly',
    tags: ['WordPress', 'Rezervácie', 'Custom produkt'],
    result: 'Rezervačný tok',
    resultDetail: 'rezervačný flow pre zákazné produkty s jednoduchým dopytovacím procesom',
    description: 'WordPress web s rezervačným tokom pre zákazné nosiče. Dôraz na prehľadný dopytovací proces a jednoduchú objednávku.',
    liveUrl: 'https://boxynosice.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://boxynosice.sk',
  },
  {
    id: 6,
    name: "Grey's",
    category: 'Webová stránka',
    type: 'od-nuly',
    tags: ['WordPress', 'Lead Form', 'Zdravotníctvo'],
    result: 'Lokálna prezentácia',
    resultDetail: 'dentálna chirurgia so silnou lokálnou prezentáciou a dôveryhodnosťou',
    description: 'WordPress web pre dentálnu chirurgiu MUDr. Siváka. Zameranie na dôveru, generovanie dopytov a lokálnu viditeľnosť.',
    liveUrl: 'https://greys.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://greys.sk',
  },
  {
    id: 7,
    name: 'Meridia',
    category: 'Webová stránka',
    type: 'od-nuly',
    tags: ['React', 'Wellness', 'Prešov'],
    result: 'Atmosféra & dôvera',
    resultDetail: 'masážne služby v Prešove s dôrazom na atmosféru a jasnú ponuku',
    description: 'React web pre masážne štúdio v Prešove. Dôraz na atmosféru, dôveru a prehľadnú prezentáciu ponuky.',
    liveUrl: 'https://meridia.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://meridia.sk',
  },
  {
    id: 8,
    name: 'Dávid Kočan',
    category: 'Osobný brand',
    type: 'od-nuly',
    tags: ['WordPress', 'Osobný brand', 'Prezentácia'],
    result: 'Osobná kredibilita',
    resultDetail: 'osobný prezentačný web s jasnou ponukou a čistou profesionálnou prezentáciou',
    description: 'Osobná prezentačná webstránka pre finančného poradcu. Dôraz na jasnosť ponuky, kredibilitu a čistú osobnú prezentáciu.',
    liveUrl: 'https://davidkocan.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://davidkocan.sk',
  },
  {
    id: 9,
    name: 'CREATE UP',
    category: 'Firemný web',
    type: 'od-nuly',
    tags: ['WordPress', 'Rezervácie', 'Eventy'],
    result: 'Event vizuál',
    resultDetail: 'prezentačný web pre eventový priestor so silnou vizuálnou identitou',
    description: 'Prezentačný web pre eventové a podcastové štúdio v Prešove. Silný vizuálny smer a jasné CTA na rezervácie.',
    liveUrl: 'https://createup.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://createup.sk',
  },
  {
    id: 10,
    name: 'Matronalis',
    category: 'Firemný web',
    type: 'od-nuly',
    tags: ['WordPress', 'Multijazyčnosť', 'Recruitment'],
    result: 'Multijazyčná platforma',
    resultDetail: 'personálna agentúra s multijazyčným obsahom, pracovnými pozíciami a CV formulárom',
    description: 'WordPress web pre personálnu agentúru. Multijazyčný obsah, inzeráty pracovných pozícií a formulár na odosielanie CV.',
    liveUrl: 'https://www.matronalis.eu',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://www.matronalis.eu',
  },
  {
    id: 11,
    name: 'Prorok CRM',
    category: 'CRM & Systémy',
    type: 'od-nuly',
    tags: ['CodeIgniter', 'Frontend', 'Backend'],
    result: 'CRM na mieru',
    resultDetail: 'vývoj frontendu a backendu, nové funkcie a úpravy dizajnu v existujúcom systéme',
    description: 'CodeIgniter projekt - frontend aj backend vývoj, implementácia nových funkcií a dizajnové úpravy v existujúcom CRM systéme.',
    liveUrl: 'http://prorok.it',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/http://prorok.it',
  },
  {
    id: 12,
    name: 'Casino Zona',
    category: 'Webová stránka',
    type: 'od-nuly',
    tags: ['WordPress', 'Blog', 'Affiliate'],
    result: 'Obsahový model',
    resultDetail: 'affiliate web zameraný na správy a analýzy z kasíno sektora',
    description: 'WordPress webstránka s obsahovým a affiliate modelom. Novinky, bonusy a analýzy zo sveta online kasín.',
    liveUrl: 'https://casino-zona.sk',
    image: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://casino-zona.sk',
  },
  {
    id: 13,
    name: 'Redesign - príklad (nahraď vlastným)',
    category: 'Webová stránka',
    type: 'redesign',
    tags: ['Redesign', 'Pred / Po', 'Placeholder'],
    result: 'Vizuálny skok',
    resultDetail: 'nahraď tento projekt reálnym klientom ktorého si prerobil',
    description: 'Ukážková karta redesignu. Potiahnite slider na porovnanie pred/po. Nahraď obrázky skutočnými screenshotmi zo svojho redesign projektu.',
    beforeImage: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://greys.sk',
    afterImage: 'https://image.thum.io/get/width/1440/crop/900/noanimate/https://glowdent.sk',
  },
];

export const redesignProjects = projects.filter((p) => p.type === 'redesign');
export const fromScratchProjects = projects.filter((p) => p.type === 'od-nuly');
